const NothingToShow = ({ name = "data", colSpan = 1 }) => {
  return (
    <tbody>
      <tr>
        <td className="text-center" colSpan={colSpan}>
          <span>No {name} to show</span>
        </td>
      </tr>
    </tbody>
  );
};

export default NothingToShow;
